








import { SXCompany } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WCompanyAbout extends BaseComponent {
	@Prop({ type: SXCompany, required: true })
	company!: SXCompany;
}
